module.exports = __webpack_public_path__ + "img/Products_Desktop-Recovered_05.38f8f75d.jpg";